import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    headerName: "",
    headerImage: "",
    headerImageSrc: "",
    isFullscreen : false,
}

const headerSlice = createSlice({
    name: "header",
    initialState,
    reducers: {
        setHeaderDetails: (state, action) => {
            return { ...state, ...action.payload };
        }
    },
});

export const {
    setHeaderDetails,
} = headerSlice.actions;

export default headerSlice.reducer;
